import { createSlice } from '@reduxjs/toolkit'
import { getGameSetting } from 'redux-store/thunk/gameSettings.thunk'
import { generateServerSeed } from 'redux-store/thunk/user.thunk'
import { generateClientSeed } from 'utils/common-functions/index'
import { DEFAULT_MUSIC_VOLUME, DEFAULT_SOUND_VOLUME } from 'utils/constants/index'

const RESTORE_VOLUME_DEFAULT = 0.5

const initialState = {
  systemGameData: null,
  allCurrencies: [],
  gameSettings: [],
  gameSettingLoader: false,
  clientSeed: generateClientSeed() || '',
  serverSeedHash: '',
  gameMusic: DEFAULT_MUSIC_VOLUME > 0,
  gameMusicVolume: DEFAULT_MUSIC_VOLUME,
  gameSound: DEFAULT_SOUND_VOLUME > 0,
  gameSoundVolume: DEFAULT_SOUND_VOLUME,
  previousGameSoundVolume: RESTORE_VOLUME_DEFAULT,
  previousGameMusicVolume: RESTORE_VOLUME_DEFAULT,
  firstInteraction: false,
  showChat: false,
  isChatCollapse: false
}

const {
  actions: {
    setGameSoundVolume,
    toggleGameMute,
    setAllcurrency,
    setGameSettings,
    setGameSettingLoader,
    setNewClientSeed,
    setServerSeedHash,
    setGameMusic,
    updateGameSetting,
    setGameSound,
    setGameMusicVolume,
    setFirstInteraction,
    setShowChat,
    setChatCollapse
  },
  reducer
} = createSlice({
  name: 'gameSetting',
  initialState,
  reducers: {
    setFirstInteraction: (state, action) => {
      return {
        ...state,
        firstInteraction: true
      }
    },
    setGameMusicVolume: (state, action) => {
      const volume = action.payload
      return {
        ...state,
        gameMusicVolume: volume,
        ...(volume > 0 && { previousGameMusicVolume: volume })
      }
    },
    setGameSoundVolume: (state, action) => {
      const volume = action.payload
      return {
        ...state,
        gameSoundVolume: volume,
        ...(volume > 0 && { previousGameSoundVolume: volume })
      }
    },
    toggleGameMute: (state) => {
      const isMuted = state.gameSoundVolume === 0 && state.gameMusicVolume === 0
      if (isMuted) {
        const soundVol = state.previousGameSoundVolume || RESTORE_VOLUME_DEFAULT
        const musicVol = state.previousGameMusicVolume || RESTORE_VOLUME_DEFAULT
        return {
          ...state,
          gameSoundVolume: soundVol,
          gameMusicVolume: musicVol
        }
      }
      return {
        ...state,
        previousGameSoundVolume: state.gameSoundVolume || state.previousGameSoundVolume,
        previousGameMusicVolume: state.gameMusicVolume || state.previousGameMusicVolume,
        gameSoundVolume: 0,
        gameMusicVolume: 0
      }
    },
    setAllcurrency: (state, action) => ({
      ...state,
      allCurrencies: action.payload
    }),
    setGameSettings: (state, action) => ({
      ...state,
      gameSettings: action.payload
    }),
    setGameSettingLoader: (state, action) => ({
      ...state,
      setGameSettingLoader: action.payload
    }),
    setNewClientSeed: (state, action) => ({
      ...state,
      clientSeed: action.payload
    }),
    setServerSeedHash: (state, action) => ({
      ...state,
      serverSeedHash: action.payload
    }),
    setGameMusic: (state, action) => ({
      ...state,
      gameMusic: !state.gameMusic
    }),
    setGameSound: (state, action) => ({
      ...state,
      gameSound: !state.gameSound
    }),
    updateGameSetting: (state, action) => {
      return {
        ...state,
        systemGameData: action.payload
      }
    },
    setShowChat: (state, { payload }) => ({
      ...state,
      showChat: payload
    }),
    setChatCollapse: (state, { payload }) => ({
      ...state,
      isChatCollapse: payload
    })

  },
  extraReducers: (builder) => {
    builder
      .addCase(getGameSetting.fulfilled, (state, action) => {
        return {
          ...state,
          systemGameData: action.payload,
          gameSettingLoader: false
        }
      })
      .addCase(generateServerSeed.fulfilled, (state, action) => {
        return {
          ...state,
          serverSeedHash: action.payload?.serverSeedHash ?? ''
        }
      })
      .addCase(generateServerSeed.rejected, (state, action) => {
        return {
          ...state
        }
      })
  }
})

export default reducer
export {
  setGameSoundVolume,
  toggleGameMute,
  setAllcurrency,
  setGameSettings,
  setGameSettingLoader,
  setNewClientSeed,
  setGameMusic,
  setServerSeedHash,
  updateGameSetting,
  setGameSound,
  setGameMusicVolume,
  setFirstInteraction,
  setShowChat,
  setChatCollapse
}
